import Link from 'app/shared/components/Link/Link';
import { Button } from 'app/shared/components/Button/Button';
import { ReactNode } from 'react';

interface ButtonLinkProps {
  children: ReactNode;
  onClick?: () => void;
  href: string;
  qaID?: string;
  blank?: boolean;
  size?: 'small' | 'large';
}

const ButtonLink = ({
  children,
  href,
  blank,
  onClick,
  qaID,
  size = 'small',
}: ButtonLinkProps) => {
  return (
    <Link href={href} blank={blank} qaID={qaID} onClick={onClick}>
      <Button variant="link" size={size}>
        {children}
      </Button>
    </Link>
  );
};

export { ButtonLink };
